import { PartialEnvVarMap } from "../types/envVar";

const developmentEnvVars: PartialEnvVarMap = {};

export default developmentEnvVars;
